import { MsalAuthenticationTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { createTheme, ThemeOptions, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { useMemo } from 'react';
import App from './App';
import store from './store';
/* tslint:disable:no-import-side-effect */
import { InteractionType } from '@azure/msal-browser';
import {
    blue,
    blueGrey,
    brown,
    cyan,
    deepPurple,
    green,
    grey,
    indigo,
    lightGreen,
    lime,
    orange,
    pink,
    purple,
    red,
    teal
} from '@mui/material/colors';
import { locale } from 'moment';
import 'moment/locale/sv';
import { Provider } from 'react-redux';
import 'typeface-roboto';
import './index.css';
import { appEnvironment } from './utils';

locale('sv');

const commonTheme: ThemeOptions = {
    mixins: {
        toolbar: {
            minHeight: 48
        }
    }
};

const createProdTheme = () => createTheme();
const extraColors = {
    lime: { main: lime[500] },
    teal: { main: teal[500] },
    cyan: { main: cyan[500] },
    blue: { main: blue[500] },
    brown: { main: brown[500] },
    deepPurple: { main: deepPurple[500] },
    green: { main: green[500] },
    gray: { main: grey[500] },
    orange: { main: orange[500] },
    indigo: { main: indigo[500] },
    lightGreen: { main: lightGreen[500] },
    pink: { main: pink[500] },
    red: { main: red[500] },
    purple: { main: purple[500] },
    blueGrey: { main: blueGrey[500] }
};
const createNonProdTheme = () =>
    createTheme({
        typography: {
            fontSize: 14
        },
        palette: {
            background: {
                default: '#fafafa'
            },
            primary: {
                main: '#00897b'
            },
            secondary: {
                main: '#ec407a'
            },
            ...extraColors
        }
    });

const theme = (() => {
    const envTheme = appEnvironment === 'Production' ? createProdTheme() : createNonProdTheme();
    envTheme.palette = { ...envTheme.palette, ...extraColors };
    return {
        ...envTheme,
        ...commonTheme
    };
})();
export const RestrictedApp = () => {
    const { instance, accounts } = useMsal();

    const accountInfo = useMemo(() => {
        return accounts[0];
    }, [accounts]);

    const request = {
        scopes: ['User.Read', `api://${process.env.REACT_APP_API}/PricePrg.User`]
    };

    return (
        <>
            <UnauthenticatedTemplate>
                <p>Authenticating...</p>
            </UnauthenticatedTemplate>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={request}
            >
                <Provider store={store}>
                    <ThemeProvider theme={theme}>
                        <SnackbarProvider maxSnack={4}>
                            <App
                                accountInfo={accountInfo}
                                logout={() => instance.logoutRedirect({ account: accountInfo })}
                            />
                        </SnackbarProvider>
                    </ThemeProvider>
                </Provider>
            </MsalAuthenticationTemplate>
        </>
    );
};
